import ReactDom from 'react-dom';
import App from './app';

import './global.scss';

ReactDom.render(<App />, document.getElementById('root'));
